import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAtlO_aBNHiLkBld2x7osHAfdM2yOGnOIU",
  authDomain: "nethran-crackers.firebaseapp.com",
  projectId: "nethran-crackers",
  storageBucket: "nethran-crackers.firebasestorage.app",
  messagingSenderId: "284150130061",
  appId: "1:284150130061:web:3958411bf879da6a9489c4"
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
